module.exports = __webpack_public_path__ + "img/td.ed579e72.svg";